import pdfMake from 'pdfmake/build/pdfmake';
import {TableCell, TDocumentDefinitions} from "pdfmake/interfaces";
import * as pdfFonts from 'pdfmake/build/vfs_fonts';

import {formatDate, formatPeso, geoString, hasModule, translateText} from '../../helpers';
import {IPago} from "../../redux/types/IPago";
import {ICompania} from "../../redux/types/ICompania";
import moment from 'moment';
import Strings from "../../assets/strings";
import {RootState, store} from "../../redux/store";
import {MODULO_USUARIO} from "../../helpers/CONSTANTES";
const fonts = require('../../assets/fonts/fonts');

export async function reciboPagoPDF(pago:IPago, compania:ICompania) {

    let {uiColor = "#17a2b8", firma } = (store.getState() as RootState).auth?.user ?? {};



    let formatoRecibo:string[] = [];
    try {
        formatoRecibo = compania?.formatoRecibo?.split(",")??[];
    }
    catch(error) {
        formatoRecibo = []
    }

    (pdfMake as any).vfs = pdfFonts.pdfMake.vfs;
    pdfMake.vfs = fonts.pdfMake.vfs;
    pdfMake.fonts = {
        'Calibri': {
            normal: `Calibri_Regular.ttf`,
            bold: `Calibri_Bold.ttf`,
            italics: `Calibri_Light_Italic.ttf`,
            bolditalics: `Calibri_Bold_Italic.ttf`
        },
    }
    pdfMake.tableLayouts = {
        customLayout: {
            hLineWidth: function (i, node) {
                if (i === 0 || i === node.table.body.length) {
                    return 0.2;
                }
                return (i === node.table.headerRows) ? 2 : 1;
            },
            paddingTop: function (i) {
                return i === 0 ? 5 : 5;
            },
            paddingBottom: function (i) {
                return i === 0 ? 0 : 0;
            },
            paddingLeft: function (i) {
                return i === 0 ? 0 : 0;
            },
        }
    }


    let docDefinition:TDocumentDefinitions = {
        pageMargins:20,
        pageSize: {
            width: 595.28,
            height: 'auto'
        },
        info:{
            title:"recibo de pago",
            author:"www.dsegura.net",
            creator:"www.prestamistapp.com",
        },
        // pageSize:{
        //     width:612.0,
        //     height:335.0
        // },
      //  pageOrientation:'landscape',
        watermark: { text: pago.fechaAnulacion?Strings.anulado:'', color: 'red', opacity: 0.2, bold: true, italics: false },
        content: [
            {
                // alignment: 'justify',
                columns: [
                    (compania.logo?  {
                        image: 'logo',
                        fit: [70, 50],
                    }:{text:""}),
                    {
                        style: 'table',
                        layout:"noBorders",
                        table: {
                            widths: ['*'],
                            body: [
                                [{text: compania.nombre, alignment: 'right', fontSize:12, color:uiColor}],
                                [{
                                    text: (compania.rnc ? geoString("rnc",true) +": "+compania.rnc+" \n" : "")+
                                          (compania.telefono ? "Tel: "+compania.telefono+" " : "")+ (compania.telefono2 ? " / "+compania.telefono2+" \n" : "")+
                                            (compania.direccion ? compania.direccion+" \n" : ""),
                                    alignment: 'right',
                                    // fontSize:
                                    italics: true
                                }],
                            ]
                        }
                    },
                ]
            },

            {
                style: 'table',
                layout:"noBorders",
                marginTop:10,

                table: {
                    widths: ['*', '*', '*'],
                    body: [
                        [

                            {text: "No. "+pago.id, decoration: 'underline'},
                            {text: (pago.tipo===4?translateText("ajusteCapital")+" / "+translateText("reenganche"):translateText("reciboDePago")).toLocaleUpperCase(), fontSize:18, color:uiColor, bold:true, alignment:"center"},
                            {text: formatDate(pago.fecha)+" "+moment(pago.fecha).format("hh:mm a"), alignment:"right", decoration: 'underline'},
                        ],
                    ]
                }
            },
            // { qr: "greeting" },


            {
                style: 'table',
                layout:"customLayout",
                table: {
                    widths: ['auto', "*"],
                    body: [
                        [
                            {text:(pago.tipo===4?translateText("entregadoA"):translateText("recibido")+" "+translateText("de")+": " ).toLocaleUpperCase(), bold:true,border: [false, false, false, false]},
                            {text:pago.cliente?.toLocaleUpperCase(),border: [false, false, false, true]}
                        ],
                    ]
                }
            },
            {
                style: 'table',
                layout:"customLayout",
                table: {
                    widths: ['auto', "*", "auto","auto"],
                    body: [
                        [
                            {text:Strings.laSumaDe.toLocaleUpperCase(), bold:true,border: [false, false, false, false]},
                            {text:pago.totalLetra,border: [false, false, false, true]},

                            {text:Strings.monto.toLocaleUpperCase()+": ", bold:true,border: [false, false, false, false]},
                            {text:formatPeso(pago.totalPago),border: [false, false, false, true]}
                        ],
                    ]
                }
            },
            {
                style: 'table',
                layout:"customLayout",
                table: {
                    widths: ['auto', "*"],
                    body: [
                        [
                            {text:Strings.porConceptoDe.toLocaleUpperCase(), bold:true,border: [false, false, false, false]},
                            {text:pago.concepto,border: [false, false, false, true]}
                        ],
                    ]
                }
            },
            {
                style: 'table',
                layout:"customLayout",
                table: {
                    widths: ['auto', "*"],
                    body: [
                        [
                            {text:Strings.comentario.toLocaleUpperCase()+":", bold:true,border: [false, false, false, false]},
                            {text:pago.comentario??"-",border: [false, false, false, true]}
                        ],
                    ]
                }
            },


            {
                columns:[
                    ...(pago.tipo !== 10 && pago.tipo !== 4 ?
                        [{
                            style: 'table',
                            fontSize:8,
                            marginTop:10,
                            layout: "noBorders",
                            table: {
                                // widths: ['*'],
                                body: (()=>{
                                    let row:  TableCell[][] = [[
                                        {text: ""},
                                        {text: ""}
                                    ]];

                                    if(formatoRecibo.includes("capital")){
                                        row.push([
                                            {text: Strings.capital??""},
                                            {text: ": "+formatPeso(pago.capital)}
                                        ])
                                    }
                                    if(formatoRecibo.includes("interes")){
                                        row.push([
                                            {text: Strings.interes??""},
                                            {text: ": "+formatPeso(pago.interes)}
                                        ])
                                    }
                                    if(formatoRecibo.includes("descuento") && !!pago.descuento){
                                        row.push([
                                            {text: Strings.descuento??""},
                                            {text: ": "+formatPeso(pago.descuento)}
                                        ])
                                    }
                                    if(formatoRecibo.includes("mora") && !!pago.mora){
                                        row.push([
                                            {text: Strings.mora??""},
                                            {text: ": "+formatPeso(pago.mora)}
                                        ])
                                    }
                                    if(formatoRecibo.includes("seguro") && pago.seguro){
                                        row.push([
                                            {text: Strings.seguro??""},
                                            {text: ": "+formatPeso(pago.seguro)}
                                        ])
                                    }
                                    if(formatoRecibo.includes("otros") && pago.otros){
                                        row.push([
                                            {text: Strings.otros??""},
                                            {text: ": "+formatPeso(pago.otros)}
                                        ])
                                    }

                                    return row
                                })(),
                            }
                        }]
                        :[{text: ""}]),

                    {
                        style: 'table',
                        fontSize:8,
                        marginTop:10,
                        layout: "noBorders",
                        table: {
                            // widths: ['*'],
                            body: (()=>{
                                let row:  TableCell[][] = [[
                                    {text: ""},
                                    {text: ""}
                                ]];

                                if(formatoRecibo.includes("tipoFormaPago") && !!pago.formaPagoString){
                                    row.push([
                                        {text: Strings.tipoFormaPago??""},
                                        {text: ": "+translateText(pago.formaPagoString)}
                                    ])
                                }
                                if(formatoRecibo.includes("agente") && !!pago.usuarioCreadoPor){
                                    row.push([
                                        {text: Strings.cobrador??""},
                                        {text: ": "+translateText(pago.usuarioCreadoPor)}
                                    ])
                                }
                                if(formatoRecibo.includes("proximoPago") && pago.tipo !== 10 ){
                                    row.push([
                                        {text: Strings.proximo+" "+Strings.pago},
                                        {text: ": "+formatDate(pago.fechaProximoPago)}
                                    ])
                                }
                                return row
                            })(),

                        }
                    },


                    ...(pago.tipo !== 10 ?
                        [{
                            style: 'table',
                            fontSize:8,
                            marginTop:10,
                            layout: "noBorders",
                            table: {
                                widths: ['*'],
                                body: (()=>{
                                    let row:  TableCell[][] = [[
                                        {text: ""},
                                    ]];
                                    if(formatoRecibo.includes("capitalRestante")){
                                        row.push([
                                            {text: [
                                                    {text: Strings.capitalPendiente, alignment: 'right'},
                                                    {text: " : "+formatPeso(pago.nuevoCapital), alignment: 'right'}
                                                ]},
                                        ])
                                    }
                                    if(formatoRecibo.includes("balancePendiente")){
                                        row.push([
                                            {text: [
                                                    {text: Strings.balancePendiente, alignment: 'right'},
                                                    {text: " : "+formatPeso(pago.balance), alignment: 'right'}
                                                ]}
                                        ])
                                    }

                                    return row
                                })(),
                            }
                        }]
                        :[{text: ""}]),
                ]
            },


            (formatoRecibo.includes("firma")?[
                {
                    ...(!!firma && firma.includes("http") ?
                            {
                                image: 'firma',
                                // width: 150,
                                // height: 25,
                                fit:[150,25],
                                marginLeft:220,
                                marginTop:25
                            }
                            :
                            {text:"",marginTop:25}
                    ),
                },
                {text: "_________________________\n"+Strings.firma.toLocaleUpperCase(), alignment: 'center'},
            ]:[{text:""}]),
            {text: compania.footerRecibo??"", marginTop:5, fontSize:7},


            {text: hasModule(MODULO_USUARIO.ocultarPieRecibo)? "": "PrestamistApp.com", alignment: 'right',fontSize:6, marginTop:5},



        ],
        images: {
            logo: compania.logo ?? "",
            firma: firma ?? ""
        },
        styles: {
            blueCell:{
                fillColor:"#bbbbbb",
            },
            blueCellBold:{
                fillColor:"#bbbbbb",
                bold: true,

            },
            titleCel:{
                fillColor:"#023465",
                color: '#FFF',
                bold: true,
              //  fontSize: 8,
            },
            table: {
                margin: [0, 0, 0, 0],
            },
            tableHeader: {
                bold: true,
               // fontSize: 11,
              //  fillColor:"#023465",
                color: 'black'
            }
        },
        defaultStyle: {
            fontSize: 9,
            font: 'Calibri'
            // alignment: 'justify'
        }
    }


    const pdfDocGenerator = pdfMake.createPdf(docDefinition);

    return Promise.resolve(pdfDocGenerator);
}

